import {
	USER,
	UPDATE_USER,
	DELETE_USER,
	USER_TRANSACTION,
	DELETE_TRANSACTION
} from "../types";

export const userTransactionReducer = (state = {}, action) => {
	const { type, payload } = action;

	switch (type) {
		case USER_TRANSACTION: {
			const { data } = payload;
			return data;
		}
		case DELETE_TRANSACTION: {
			return {};
		}
		default: {
			return state;
		}
	}
};
